<template>
  <div class="c-contentsCheckbox">
    <div class="c-contentsCheckbox_input">
      <div
        v-for="selectItem in requestItem.selectItemsList"
        :key="selectItem.id"
        class="c-contentsCheckbox_inputItem"
        :class="{ 'c-contentsCheckbox_inputItem-withImage': selectItem.optionJson.imageFileUrl }"
      >
        <label
          class="c-contentsCheckbox_inputLabel"
          :class="{
            'c-contentsCheckbox_inputLabel-withImage': selectItem.optionJson.imageFileUrl,
            'c-contentsCheckbox_inputLabel-withImageSelected': selectItem.optionJson.imageFileUrl && isSelected(selectItem.value)
          }"
          :name="requestItem.name"
        >
          <div
            class="c-contentsCheckbox_inputImage"
            v-if="selectItem.optionJson.imageFileUrl"
          >
            <img :src="selectItem.optionJson.imageFileUrl">
          </div>
          <c-checkbox
            size="is-small"
            :name="requestItem.name"
            :native-value="selectItem.value"
            v-model="selectedValues"
          >
            {{ selectItem.label }}
          </c-checkbox>
        </label>
      </div>
      <div class="c-contentsCheckbox_inputItem c-contentsCheckbox_inputItem-empty"></div>
      <div class="c-contentsCheckbox_inputItem c-contentsCheckbox_inputItem-empty"></div>
      <div class="c-contentsCheckbox_inputItem c-contentsCheckbox_inputItem-empty"></div><!-- flexの位置調整用 -->
    </div>
    <other-input
      :request-item="requestItem"
      :selected-values="selectedValues"
      @change="changeOther"
      @toggle="toggleOther"
    />
  </div>
</template>
<script>
import OtherInput from './OtherInput'

export default {
  name: 'ContentsCheckbox',
  components: {
    OtherInput
  },
  props: {
    requestItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedValues: []
    }
  },
  watch: {
    selectedValues() {
      const sortedValues = this.selectedValues.slice().sort((a, b) => {
        return a - b
      })
      this.$emit('change', {
        name: this.requestItem.name,
        value: sortedValues,
        isValid: this.isValid
      })
    }
  },
  computed: {
    isValid() {
      if (this.requestItem.requiredFlag && this.selectedValues.length === 0) {
        return false
      }

      return true
    }
  },
  methods: {
    isSelected(value) {
      return this.selectedValues.includes(value)
    },
    changeOther(inputItem) {
      this.$emit('change-other', {
        name: inputItem.name,
        value: inputItem.value,
        isValid: inputItem.isValid
      })
    },
    toggleOther(toggleItem) {
      this.$emit('toggle-other', {
        name: toggleItem.name,
        isShow: toggleItem.isShow
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-contentsCheckbox {
  &_input {
    display: flex;
    margin-top: -8px;

    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &_inputItem {
    margin-top: 8px;

    &-withImage {
      white-space: nowrap;
    }

    &-empty {
      margin: 0;
    }

    /deep/ .control-label {
      display: flex;
      font-size: 14px;

      align-items: center;
      justify-content: space-between;
    }
  }

  &_inputLabel {
    &-withImage {
      @include link-effect;

      display: flex;
      flex-direction: column;
      padding: 12px;
      height: 100%;
      border: 1px solid $color-gray-200;
      border-radius: 6px;
      background-color: $color-white;
      cursor: pointer;

      align-items: center;
      justify-content: flex-end;
    }

    &-withImageSelected {
      border: 1px solid $color-blue-500;
    }
  }

  &_inputImage {
    display: flex;
    flex: 1;

    align-items: center;
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-contentsCheckbox {
    &_inputItem {
      flex: 0 0 calc((100% - 8px) / 2);
      max-width: calc((100% - 8px) / 2);

      &-withImage {
        height: 128px;

        /deep/ .control-label {
          font-size: 11px;
        }
      }

      &-empty {
        height: 0;
      }
    }

    &_inputImage {
      img {
        max-width: 100px;
        max-height: 100px;
      }
    }
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-contentsCheckbox {
    &_inputItem {
      flex: 0 0 calc(100% / 3);

      &-withImage {
        flex: 0 0 calc((100% - 8px * 3) / 4);
        max-width: calc((100% - 8px * 3) / 4);
        height: 160px;
      }

      &-empty {
        height: 0;
      }
    }

    &_inputImage {
      img {
        max-width: 130px;
        max-height: 130px;
      }
    }
  }
}
</style>
